import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Box, IconButton, Tooltip, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { getSVG } from '../../utils/getSvg'

/** The header's notifications button: a quiet bell, with a dot while something is unread. */
const HeaderBell = forwardRef(({ unread, label, onClick, describedBy }, ref) => {
  const theme = useTheme()
  return (
    <Tooltip title={label}>
      <IconButton
        ref={ref}
        onClick={onClick}
        aria-describedby={describedBy}
        aria-label={label}
        sx={{
          position: 'relative',
          flexShrink: 0,
          ml: 0.5,
          width: 40,
          height: 40,
          borderRadius: '10px',
          '&:hover': { backgroundColor: alpha(theme.palette.text.primary, 0.06) },
        }}
      >
        {getSVG('lucide-bell', theme.palette.text.secondary, { width: 20, height: 20 }, undefined, undefined, true)}
        {unread > 0 && (
          <Box
            component="span"
            data-testid="header-bell-unread"
            sx={{
              position: 'absolute',
              top: 8,
              right: 9,
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: theme.palette.error.main,
              // Cut out of the bell so the dot reads on any header colour.
              border: `2px solid ${theme.palette.background.paper}`,
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  )
})

HeaderBell.displayName = 'HeaderBell'

HeaderBell.propTypes = {
  unread: PropTypes.number,
  label: PropTypes.string,
  onClick: PropTypes.func,
  describedBy: PropTypes.string,
}

HeaderBell.defaultProps = {
  unread: 0,
  label: '',
}

export default HeaderBell
